// Module
var code = "<div class=\"container\"><div class=\"col-md-9\"><div class=\"form-grop\"><h3>Gym log</h3><div class=\"form-group\"><a ui-sref=\"gyms({tab: &#39;team&#39;})\">back</a></div><gym-logs display-gym=\"true\" user-id=\"userId\"></gym-logs></div></div></div>\n";
// Exports
module.exports = code;